import React from 'react';
import { withRouter } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';

import { useBreadcrumb } from '../../../context/breadcrumb';

import { styles } from './styles';

function QuickLinks({ history, links }) {
  const classes = styles();
  const { updateBreadcrumb } = useBreadcrumb();

  const handleLinkClick = (navigationRoute, navigationState = null, name) => {
    if (navigationRoute.external) {
      if (navigationState) {
        // eslint-disable-next-line
        if (navigationState.hasOwnProperty('programId')) {
          navigationRoute.path += `/program/${navigationState.programId}`;
        }

        /*
          Section scoped for additional params in future.
        */
      }

      if (navigationRoute.external.newTab) {
        window.open(navigationRoute.path, '_blank');
      } else {
        window.location.href = navigationRoute.path;
      }
    } else {
      localStorage.setItem(
        'navigationRoute',
        JSON.stringify(navigationRoute.path),
      );
      updateBreadcrumb({
        key: navigationRoute.key,
        name: navigationRoute.name,
        path: navigationRoute.path,
      });

      history.push(navigationRoute.path, navigationState);
    }
  };

  return (
    <div className={classes.root}>
      {links.map((link) => {
        return (
          <Card
            className={`${classes.card} ${
              link.disabled || link.navigationRoute == null
                ? classes.noCursor
                : ''
            }`}
            key={link.name}
          >
            <CardActionArea
              className={classes.thumbnail}
              onClick={() =>
                link.disabled || link.navigationRoute == null
                  ? null
                  : handleLinkClick(
                      link.navigationRoute,
                      link.navigationState,
                      link.name,
                    )
              }
              disabled={link.disabled || link.navigationRoute == null}
            >
              <img
                className={classes.thumbnailImage}
                src={link.thumbnail}
                title={link.name}
                alt={link.name}
              />
              <Typography className={classes.title}>{link.name}</Typography>
            </CardActionArea>
          </Card>
        );
      })}
    </div>
  );
}

export default withRouter(QuickLinks);
